/*
 * @Author: Teemo Ding
 * @Date: 2021-09-30 09:23:43
 * @LastEditTime: 2022-06-10 14:30:00
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelTax/index.tsx
 */
import CommonHeader from '@/src/components/CommonHeader';
import RouteBlock from '@/src/constrains/RouterBlock/RouterBlock';
import useBreadCrumbData from '@/src/pages/SalesCannelVersion/Hooks/useBreadCrumbData';
import {
  init_salesChannelTaxData,
  save_salesChannelTaxData,
} from '@/src/request/salesChannel/setting/tax';
import {
  isUserValid,
  salesChannelResourceNameGenerator,
} from '@/src/tools/getUserInfo';
import { getI18nFromGeneral } from '@/src/tools/tools';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from '@/src/types/common/resources';
import { Form, Spin, message } from 'antd';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import TaxRuleNameLocalisation from './TaxRuleNameLocalisation';
import TaxSetting from './TaxSetting';
import { default as css, default as styles } from './css.module.less';

const permissions = (uuid: string) => {
  const view_tax_settings = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelTax,
        operation: EnumOperation.view_tax_settings,
        uuid,
      }),
    ],
  });
  const edit_tax_setting = isUserValid({
    source: EPermissionSource.salesChannel,
    resourcesGroup: [
      salesChannelResourceNameGenerator({
        category: EnumCategory.SalesChannelSettings,
        subCategory: EnumSubCategory.ChannelTax,
        operation: EnumOperation.edit_tax_setting,
        uuid,
      }),
    ],
  });

  return {
    view_tax_settings,
    edit_tax_setting,
  };
};

const SalesChannelTax = () => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [loading, setLoading] = useState(true);
  const [hasModified, setHasModified] = useState(false);
  const [taxDetail, setTaxDetail] = useState<any>();
  const params: any = useParams();
  const history = useHistory();
  const [form] = Form.useForm();
  const { uuid: salesChannelUuid } = params;
  const { view_tax_settings, edit_tax_setting } = permissions(salesChannelUuid);
  const { loading: breadCrumbLoading, breadcrumbData } = useBreadCrumbData({
    lastSecond: getI18n('general.sider.settings'),
    lastOne: getI18n('general.tax'),
  });

  useEffect(() => {
    if (view_tax_settings) {
      init_salesChannelTaxData(salesChannelUuid).then((data) => {
        setTaxDetail(data);
        form.setFieldsValue({
          localization: data.localization,
          taxInclusion: data.taxInclusion,
          taxRulesEnabled: data.taxRulesEnabled,
          taxRules: data.taxRules,
        });
        setLoading(false);
      });
    } else {
      setLoading(false);
    }
  }, []);

  const onGoBackClick = () => {
    history.push(`/salesChannel/settings/${salesChannelUuid}`);
  };

  const onFinish = (values) => {
    values.uuid = taxDetail?.uuid || '';
    save_salesChannelTaxData(values).then((data) => {
      message.success(getI18n('general.savesuccess'));
      setHasModified(false);
    });
  };

  return (
    <Spin spinning={loading || breadCrumbLoading}>
      <RouteBlock
        onConfirm={(f) => f()}
        okText={getI18nFromGeneral('general.commonHeader.discard_text')}
        scrollToFirstError
        active={hasModified}
        title={getI18nFromGeneral('general.commonHeader.discard_header')}
        content={getI18nFromGeneral('general.commonHeader.discard_content')}
      />
      <CommonHeader
        breadcrumbData={breadcrumbData}
        onGoBackClick={onGoBackClick}
        onSubmit={() => form.submit()}
        onSaveDisable={!hasModified}
        onDiscard={onGoBackClick}
      />
      <div className={styles.commonContainer}>
        <Form
          name='salesCannelDetail'
          form={form}
          className={css.formClass}
          initialValues={{}}
          onFinish={onFinish}
          onValuesChange={() => {
            setHasModified(true);
          }}>
          <TaxSetting
            disabled={!view_tax_settings}
            disableEdit={!edit_tax_setting}
          />
          <TaxRuleNameLocalisation
            disabled={!view_tax_settings}
            disableEdit={!edit_tax_setting}
          />
        </Form>
      </div>
    </Spin>
  );
};

export default SalesChannelTax;
